<template>
    <div id="app">
     
 <!-- 匹配路由 -->
 <router-view></router-view>

    
    </div>
</template>

<script>
export default {
    
    components : {
       
    }
}
</script>

<style lang="less">
html,body,h3{
    margin: 0;
    padding: 0;
}
</style>